<template>
  <div class="group-container">
    <slot/>
  </div>

</template>
